import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseV3PanelComponent } from './license-v3-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LicensePanelItemModule } from './components/license-panel-item/license-panel-item.module';
import { SimplebarAngularModule } from 'simplebar-angular';

@NgModule({
  declarations: [LicenseV3PanelComponent],
  exports: [LicenseV3PanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    LicensePanelItemModule,
    SimplebarAngularModule
  ],
})
export class LicenseV3PanelModule { }
